// Production frontend config, used only when building for deployment.
// Mounted over easyex-bp/src/config.js by the deploy build command in README.md.
// Mirrors easyex-bp/src/config-easyex.js.
export const loobackApiUrl = "https://api.easyextransport.com";
export const apiUrl = "https://api.easyextransport.com";
export const s3BucketPrefix = "easyex-bp-";
export const logoText = "Easyex Warehouse System";
export const appTitle = 'EasyEx Warehouse';
